import { OrderSummaryPdfDocument } from './OrderSummaryPdfDocument';
import { InvoiceSummaryPdfDocument } from './InvoiceSummaryPdfDocument';
import { DeliveryNotePdfDocument } from './DeliveryNotePdfDocument';
import { MissingNotePdfDocument } from './MissingNotePdfDocument';
import { CreditNotePdfDocument } from './CreditNotePdfDocument';

/** @typedef {import('react').FC<any>} PdfTemplateComponent */

export const PDF_TEMPLATE_IDS = {
    ORDER_SUMMARY: 'order-summary',
    INVOICE_SUMMARY: 'invoice-summary',
    DELIVERY_NOTE: 'delivery-note',
    MISSING_NOTE: 'missing-note',
    CREDIT_NOTE: 'credit-note',
};

/** @type {Record<string, { id: string; title: string; description: string; component: PdfTemplateComponent }>} */
export const pdfTemplateRegistry = {
    [PDF_TEMPLATE_IDS.ORDER_SUMMARY]: {
        id: PDF_TEMPLATE_IDS.ORDER_SUMMARY,
        title: 'Order summary',
        description: 'Full order with cart lines, totals, billing and delivery.',
        component: OrderSummaryPdfDocument,
    },
    [PDF_TEMPLATE_IDS.INVOICE_SUMMARY]: {
        id: PDF_TEMPLATE_IDS.INVOICE_SUMMARY,
        title: 'Invoice summary',
        description: 'Invoice-oriented header with same body as order print.',
        component: InvoiceSummaryPdfDocument,
    },
    [PDF_TEMPLATE_IDS.DELIVERY_NOTE]: {
        id: PDF_TEMPLATE_IDS.DELIVERY_NOTE,
        title: 'Delivery note',
        description: 'Delivery address and items to deliver (no billing or totals).',
        component: DeliveryNotePdfDocument,
    },
    [PDF_TEMPLATE_IDS.MISSING_NOTE]: {
        id: PDF_TEMPLATE_IDS.MISSING_NOTE,
        title: 'Missing note',
        description: 'Order summary and missing line items only.',
        component: MissingNotePdfDocument,
    },
    [PDF_TEMPLATE_IDS.CREDIT_NOTE]: {
        id: PDF_TEMPLATE_IDS.CREDIT_NOTE,
        title: 'Credit note',
        description: 'Credit lines, totals, billing and delivery.',
        component: CreditNotePdfDocument,
    },
};

export function listPdfTemplates() {
    return Object.values(pdfTemplateRegistry).map(({ id, title, description }) => ({
        id,
        title,
        description,
    }));
}

/** @param {string} templateId */
export function getPdfTemplateEntry(templateId) {
    return pdfTemplateRegistry[templateId] ?? null;
}
